export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_06.31b03ea1.jpg";